import { HeaderV2LayoutAction } from "../../../../../legacy/components/HeaderV2/stores/header-v2-layout-store";
import type { IHeaderV2Store } from "../../../../../legacy/components/HeaderV2/stores/header-v2-store";
import type { ILayoutStylesStore } from "../../../../../types/layout/layout-styles.type";
import type { IRouteWrapperVariant } from "../../../../../types/layout/route-wrapper-variant.interface";

export class FirstLevelRouteWrapperVariant implements IRouteWrapperVariant {
  get sidebarAvailable(): boolean {
    return true;
  }
  get headerAvailable(): boolean {
    return true;
  }
  get bottomNavigationAvailable(): boolean {
    return true;
  }

  get layoutStyles(): ILayoutStylesStore {
    return {};
  }

  get titleAvailable(): boolean {
    return false;
  }

  getVariantHeaderSettings(): IHeaderV2Store {
    return {
      layoutStore: {
        actions: [HeaderV2LayoutAction.aiAssistant, HeaderV2LayoutAction.search, HeaderV2LayoutAction.notification],
        showLogoOnMobile: true,
      },
    };
  }
}
